import { IProjectItemCapacityOverride } from '../../interfaces/iproject-item-capacity-override';
import { Item } from '../item';
import { Project } from '../project';

export class ProjectItemCapacityOverrideBase {
  ProjectItemCapacityOverrideId: number;
  ProjectId: number;
  ItemId: number;
  OilCapacity: number | null;
  WaterCapacity: number | null;
  GasCapacity: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Item?: Item;
  Project?: Project;

  constructor(item?: IProjectItemCapacityOverride) {
    if (item) {

      this.ProjectItemCapacityOverrideId = item.ProjectItemCapacityOverrideId;
      this.ProjectId = item.ProjectId;
      this.ItemId = item.ItemId;
      this.OilCapacity = item.OilCapacity;
      this.WaterCapacity = item.WaterCapacity;
      this.GasCapacity = item.GasCapacity;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Item = new Item(item.Item);
      this.Project = new Project(item.Project);
    }
  }
}